import { render, staticRenderFns } from "./AttendenceConfig.vue?vue&type=template&id=b61f3b90"
import script from "./AttendenceConfig.vue?vue&type=script&lang=js"
export * from "./AttendenceConfig.vue?vue&type=script&lang=js"
import style0 from "./AttendenceConfig.vue?vue&type=style&index=0&id=b61f3b90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports